/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type ChatMessage_EmbedViewer = {
    readonly user: {
        readonly salesforceData: {
            readonly respectProvisioning: boolean | null;
        } | null;
        readonly setting: {
            readonly settings: {
                readonly communication: {
                    readonly suppressMessagesByProvisioning: boolean | null;
                } | null;
            } | null;
        } | null;
    } | null;
    readonly " $refType": "ChatMessage_EmbedViewer";
};
export type ChatMessage_EmbedViewer$data = ChatMessage_EmbedViewer;
export type ChatMessage_EmbedViewer$key = {
    readonly " $data"?: ChatMessage_EmbedViewer$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"ChatMessage_EmbedViewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ChatMessage_EmbedViewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "UserSalesforceData",
          "kind": "LinkedField",
          "name": "salesforceData",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "respectProvisioning",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Setting",
          "kind": "LinkedField",
          "name": "setting",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "SettingSettings",
              "kind": "LinkedField",
              "name": "settings",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "SettingSettingsCommunication",
                  "kind": "LinkedField",
                  "name": "communication",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "suppressMessagesByProvisioning",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};
(node as any).hash = 'e0672de4a91080562eab2d2d889a0195';
export default node;
